import { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';
export var filterProperties = function filterProperties(object, propertyNames) {
  return propertyNames.reduce(function (accumulator, property) {
    var value = object[property];
    if (value !== undefined) {
      accumulator[property] = value;
    }
    return accumulator;
  }, {});
};
export var createProductExtensions = function createProductExtensions(extensionsWhitelist) {
  return function (options) {
    var filteredOptions = filterProperties(options, extensionsWhitelist);
    return new CrossFlowExtensions(filteredOptions);
  };
};
export var combineExtensions = function combineExtensions() {
  for (var _len = arguments.length, extensions = new Array(_len), _key = 0; _key < _len; _key++) {
    extensions[_key] = arguments[_key];
  }
  var combinedOptions = Object.assign.apply(Object, [{}].concat(extensions));
  return new CrossFlowExtensions(combinedOptions);
};